import React, { useEffect } from "react";

import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";

import Spinner from "../../common/components/spinner/Spinner";

import { backendApi } from "../../app/services/backendApi";

import CardService from "../../common/components/cardService/CardService";

import { useDispatch } from "react-redux";
import styles from "../../styles/serviceMenu.module.css";
import { clearTarget, setExistingServices } from "../display/displaySlice";

import { useKeycloak } from "../../providers/KeycloakProvider";

/** ------------------------------------------------------------------------ */
const ServiceMenu = () => {
  const { initialized } = useKeycloak();
  const dispatch = useDispatch();

  const [triggerAllServices, responseAllServices] = backendApi.endpoints.getAllServices.useLazyQuery();

  useEffect(() => {
    if (initialized) {
      dispatch(clearTarget());
      triggerAllServices();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialized]);

  useEffect(() => {
    if (responseAllServices.data !== undefined) {
      let list = [];
      responseAllServices.data.forEach((service) => {
        list.push(service.name);
      });
      dispatch(setExistingServices(list));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [responseAllServices]);

  //if (responseAllServices?.data?.length > 0) {
  if (!initialized) {
    return <Spinner />;
  }

  if (responseAllServices.status === "fulfilled") {
    return (
      <>
        <div style={{ paddingBottom: "66px" }}>
          <Box sx={{ flexGrow: 1 }} className={styles.boxContent}>
            <Grid container direction="row" rowSpacing={0} columnSpacing={2} justifyContent="left" alignItems="flex-start" className={styles.mainContent} columns={{ xs: 2, sm: 4, md: 8, lg: 10, xl: 14 }}>
              {responseAllServices.data.map((servProps, index) => (
                <Grid key={`service-${servProps.id || index}`} className={styles.serviceContent} size={{ xs: 2, sm: 2, md: 2, lg: 2 }}>
                  <CardService props={servProps} />
                </Grid>
              ))}
            </Grid>
          </Box>
        </div>
      </>
    );
  } //if
  else if (responseAllServices.status === "rejected") {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "70vh" }}>
        <Grid container direction="column" alignItems="center" spacing={3} sx={{ maxWidth: 600 }} className={styles["no-authorization"]}>
          <Grid item>
            <Typography variant="h5" color="error" align="center">
              Droits d'accès insuffisants
            </Typography>
          </Grid>
          <Grid item>
            <img src="/error-401.avif" alt="Erreur 401" style={{ maxWidth: "100%", height: "auto" }} />
          </Grid>
        </Grid>
      </Box>
    );
  } else {
    return <Spinner />;
  }
};

export default ServiceMenu;
